module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAMAAADNGvrUAAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMA+e/l3BQQ9NXOt41gVUxDOzMrJR8ZBMa+rIaCdW1qXQ0IAZM35gAAAJxJREFUKM+N00cSwzAMA8DYltx7Sa/4/yNDX4HMMDruQRJJ8PD3eV3jD22ARvUG4CF6N70cWZ+mtWhrev6wdglwerP2plXOOpiWkXUsgLCxTimQrazzrgvrkgHpzLruOrFuAShG1lgCycCaV6a9aDDtpJU1gJaM2LlEn9QPeuVo8X6rtLE6Bm9oOmI/EBofDZsbTQ2yxt5fEl0pPV9V0hF7tKj9YQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/bannerL.png
// module id = Xnsr
// module chunks = 1